module.exports = __webpack_public_path__ + "static/media/serone.a24bd472.png";